<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
@import '@/../../../ui-kit/src/scss/index.scss';
@import '@/scss/index.scss';
</style>
